import LoginPage from './login';

export default LoginPage;